export default __webpack_public_path__ + "static/media/xls.6a22196b.svg";